import React, { useState, useRef, useEffect } from 'react'

import { Form, Button, Alert, ListGroup } from 'react-bootstrap'

import toast from 'react-hot-toast'

import { fetchAutoTranscribeStatus, ASR_IN_PROGRESS } from '../api'

import UploadBar from '../UploadBar'

import TranscriptList from '../TranscriptList'

import { languages } from '../../Utils/languages.js'

export default (props) => {
    const {
        handleAutoTranscribe,
        refreshMediaData,
        id,
        pendingASRs,
        mediaData
    } = props


    const [activeSort, setActiveSort] = useState('createdAt');
    const [activeSortType, setActiveSortType] = useState('desc');
    const [numSpkInput, setNumSpkInput] = useState('')
    const [showOptions, setShowOptions] = useState(false)
    const [inputFocused, setInputFocused] = useState(false)
    const [menuWidth, setMenuWidth] = useState(null)
    const [hoveredOption, setHoveredOption] = useState('')
    const inputRef = useRef(null)
    const containerRef = useRef(null)
    const speakerOptions = ['1','2','3','4','5']
    const submittedNumSpk = numSpkInput.trim() === '' ? '-1' : numSpkInput

    useEffect(() => {
        if (!showOptions) return
        const handleOutsideClick = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setShowOptions(false)
            }
        }
        document.addEventListener('mousedown', handleOutsideClick)
        return () => document.removeEventListener('mousedown', handleOutsideClick)
    }, [showOptions])

    const renderCurrentJobs = () => {
        if (pendingASRs.length === 0) {
            return <Alert variant="dark">No jobs running currently.</Alert>
        }

        return (
            <ListGroup>
                {pendingASRs.map((asr) => (
                    <ListGroup.Item key={asr['_id']}>
                        <div>{JSON.stringify(asr)}</div>
                        <div className="mt-3">
                            <Button
                                variant="outline-secondary"
                                type="button"
                                size="sm"
                                onClick={() => {
                                    handleRefreshAutoTranscribe(asr['asrId'])
                                }}
                            >
                                Refresh
                            </Button>
                        </div>
                    </ListGroup.Item>
                ))}
            </ListGroup>
        )
    }

    const handleRefreshAutoTranscribe = async (asrId) => {
        toast
            .promise(
                fetchAutoTranscribeStatus(id, asrId),
                {
                    loading: `Checking status for ASR Request: ${asrId}`,
                    success: (data) => `${data}`,
                    error: (err) => `${err}`,
                },
                {
                    error: {
                        duration: 3000,
                        icon: '🕑',
                    },
                }
            )
            .then((data) => {
                // console.log(data)
                refreshMediaData()
            })
            .catch((err) => {
                if (String(err) === ASR_IN_PROGRESS) return
                console.error(err)
            })
    }


    const handleTranscriptSorting = (event) => {
        var _sort = event.target.value.split('_');
        var sort = _sort[0];
        var type = _sort[1];

        setActiveSort(sort);
        setActiveSortType(type)
    }


    return (
        <div className="px-2 py-4 d-flex flex-column">
            <div>
                <h3>Auto Transcribe</h3>
                <h5 className="mt-4">Current Running Jobs</h5>
                <div>{renderCurrentJobs()}</div>
                <h5 className="mt-3">Send a new transcription job</h5>
                <div className="mt-3 p-4 border rounded-3 d-flex flex-column">
                    <Form onSubmit={handleAutoTranscribe}>
                        <Form.Group controlId="languageSelect">
                            <Form.Label>Language</Form.Label>
                            <Form.Control as="select" name="language" custom>
                                {languages.langData.map((item, index) => {
                                    return (
                                        <>
                                            <option value={item.val}>{item.lng} {'  '} {'(' + item.desc + ')'}</option>
                                        </>
                                    )
                                })}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="audioTypeSelect">
                            <Form.Label>Audio Type</Form.Label>
                            <Form.Control as="select" name="audioType" custom>
                                <option value="closetalk">Close Talk</option>
                                <option value="telephony">Telephony</option>
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="audioTrackSelect">
                            <Form.Label>Audio Track</Form.Label>
                            <Form.Control as="select" name="audioTrack" custom>
                                <option value="single">Single Channel</option>
                                <option value="multi">Multi Channel</option>
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="speakerCountSelect">
                            <Form.Label>Number of Speakers</Form.Label>
                            <div ref={containerRef} style={{ position: 'relative' }}>
                                <Form.Control type="hidden" name="numSpk" value={submittedNumSpk} />
                                <Form.Control
                                type="text"
                                className="custom-select"
                                inputMode="numeric"
                                value={(!inputFocused && numSpkInput === '') ? 'Auto Detect' : numSpkInput}
                                ref={inputRef}
                                onChange={(event) => setNumSpkInput(event.target.value)}
                                onClick={() => { setShowOptions(true); if (containerRef.current) setMenuWidth(containerRef.current.offsetWidth) }}
                                onFocus={() => { setInputFocused(true); if (containerRef.current) setMenuWidth(containerRef.current.offsetWidth) }}
                                onBlur={() => { setInputFocused(false) }}
                                onKeyDown={(e) => { if (e.key === 'Escape') setShowOptions(false) }}
                                placeholder=""
                                />
                                {showOptions && (
                                    <div className="dropdown-menu show bg-white" style={{ zIndex: 1000, position: 'absolute', top: 'calc(100% - 1px)', left: 0, width: menuWidth || 'auto', borderRadius: 0, border: '1px solid #ced4da'}}>
                                        <button
                                            type="button"
                                            className="dropdown-item"
                                            style={hoveredOption === 'auto' ? { backgroundColor: '#1967D2', color: '#fff' } : {}}
                                            onMouseEnter={() => setHoveredOption('auto')}
                                            onMouseLeave={() => setHoveredOption('')}
                                            onClick={() => { setNumSpkInput(''); setShowOptions(false) }}
                                        >
                                            Auto Detect
                                        </button>
                                        {speakerOptions.map((opt) => (
                                            <button
                                                type="button"
                                                key={opt}
                                                className="dropdown-item"
                                                style={hoveredOption === opt ? { backgroundColor: '#1967D2', color: '#fff' } : {}}
                                                onMouseEnter={() => setHoveredOption(opt)}
                                                onMouseLeave={() => setHoveredOption('')}
                                                onClick={() => { setNumSpkInput(opt); setShowOptions(false) }}
                                            >
                                                {opt}
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </Form.Group>
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Form>
                </div>
            </div>
            <div className="mt-4">
                <h3 className="mb-4">Upload Transcript</h3>
                <UploadBar
                    actionDialogue="Select Transcript"
                    mediaId={id}
                    uploadUrl="upload/transcript"
                    transcriptType="transcript"
                    onSuccess={refreshMediaData}
                />
            </div>
            <div className="mt-4">
                <div className='d-flex flex-row justify-content-between'>
                    <div className="md-4">
                        <h4>Transcripts</h4>
                    </div>

                    <div className="md-8">
                        <select onChange={handleTranscriptSorting} class="custom-select">
                            <option value="createdAt_desc" selected>Sort By Created Date (Latest)</option>
                            <option value="createdAt_asc">Sort By Created Date (Earliest)</option>
                            <option value="name_asc">Sort By Name (A-Z)</option>
                            <option value="name_desc">Sort By Name (Z-A)</option>
                        </select>
                    </div>
                </div>

                <div>
                    <TranscriptList
                        id={id}
                        type="transcript"
                        activeSort={activeSort}
                        activeSortType={activeSortType}
                        mediaData={mediaData}
                        refreshMediaData={refreshMediaData}
                    />
                </div>
            </div>
        </div>
    )
}
